export type DopamineAssistantPanelRequestDetail = {
  focusComposer?: boolean
}

const DOPAMINE_ASSISTANT_PANEL_EVENT = 'dopamine-assistant:panel'

export type DopamineAssistantPanelListener = (
  detail: DopamineAssistantPanelRequestDetail | undefined,
) => void

export const requestDopamineAssistantPanel = (
  detail?: DopamineAssistantPanelRequestDetail,
): void => {
  window.dispatchEvent(
    new CustomEvent(DOPAMINE_ASSISTANT_PANEL_EVENT, {detail}),
  )
}

export const subscribeToDopamineAssistantPanel = (
  listener: DopamineAssistantPanelListener,
): (() => void) => {
  const handler = (event: Event): void => {
    const detail =
      event instanceof CustomEvent
        ? (event.detail as DopamineAssistantPanelRequestDetail | undefined)
        : undefined
    listener(detail)
  }
  window.addEventListener(DOPAMINE_ASSISTANT_PANEL_EVENT, handler)
  return () =>
    window.removeEventListener(DOPAMINE_ASSISTANT_PANEL_EVENT, handler)
}
